import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Layout, Button, Dropdown, Menu, Divider } from 'antd';
import {
  ArrowLeftOutlined,
  CloseCircleFilled,
  CloseOutlined,
  DownOutlined
} from '@ant-design/icons';

const { Header } = Layout;

const AppHeader = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Chào buổi sáng';
    if (hour < 18) return 'Chào buổi chiều';
    return 'Chào buổi tối';
  };

  const changeLanguage = (lang) => {
    // i18n.changeLanguage(lang);
  };

  const languageMenu = (
    <Menu>
      <Menu.Item key="en" onClick={() => changeLanguage('vi')}>
        <span style={{ display: 'inline-flex', alignItems: 'center' }}>Tiếng Việt</span>
      </Menu.Item>
      <Menu.Item key="vi" onClick={() => changeLanguage('en')}>
        <span style={{ display: 'inline-flex', alignItems: 'center' }}>English</span>
      </Menu.Item>
    </Menu>
  );

  return (
    <Header
      style={{
        position: 'relative', // Allows absolute positioning of the close button
        display: 'flex',
        justifyContent: 'center', // Centers the title horizontally
        alignItems: 'center', // Centers the title vertically
        padding: '0 16px',
        height: '80px', // Standard header height
        backgroundColor: '#0284c7' // Default Ant Design header background
      }}>
      {/* Close Button */}
      <Button
        type="link"
        style={{
          position: 'absolute', // Position the button absolutely
          top: '8px', // Distance from the top
          left: '8px', // Distance from the left
          padding: '0px',
          borderRadius: 8,
          backgroundColor: '#FFFFFF40',
          fontWeight: 500,
          color: '#fff'
        }}
        onClick={() => navigate('/')}
        icon={<CloseOutlined />}></Button>

      {/* Title */}
      <div style={{ fontWeight: 600, color: '#fff', fontSize: '16px' }}>
        Cài đặt chỉ số đồng hồ GSWM
      </div>
    </Header>
  );
};

export default AppHeader;
